import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

export const ScrollToTop = () => {
    const { pathname } = useLocation();
    const initialized = useRef(false);

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            return;
        }

        window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
        window.parent.postMessage({ task: 'scroll_top' }, '*');
    }, [pathname]);

    return null;
};
